import * as React from "react";
import { Cta } from "../Cta";
/* istanbul ignore next */
export class Region extends React.Component {
    /* istanbul ignore next */
    render() {
        return (React.createElement("div", { className: "racing-region-selector__region", onClick: () => this.props.handler() },
            React.createElement(Cta, { label: this.props.label, selected: this.props.selected })));
    }
}
//# sourceMappingURL=Region.js.map